<template lang="pug">
.card.card--location-item
	.card__inner
		.card__img
			i.card__icon(
				:data-icon-character="letters[index]",
				aria-label="Information for Location ..."
			)
		.card__content
			h3.card__heading
				a(:href="location.url") {{ location.title }}
			.card__meta
				address.card__meta-address(v-if="location.hasHours")
					.card__meta-street {{ location.address.street }}
					.card__meta-cityStateZip {{ location.address.city }}, {{ location.address.state }} {{ location.address.zipCode }}
				.card__meta-delivery(
					v-if="!location.hasHours"
				) Delivery Service Only
				a.card__meta-phone(:href="'tel:' + location.phoneNumber") {{ location.phoneNumber }}
			a(:href="location.url").card__link Location Details
			a(v-if="location.hasHours", :href="directionsHref", target="_blank").card__directions Get Directions
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "CardItem",
	components: {},
	props: {
		location: Object,
		index: Number,
	},
	data() {
		return {
			letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
		};
	},
	computed: {
		...mapGetters([
			"tags",
			"activeTags"
		]),
		directionsHref() {
			let address = `${this.location.address.street} ${this.location.address.city} ${this.location.address.state} ${this.location.address.zipCode}`;
			return `https://www.google.com/maps/place/${encodeURI(address)}`;
		},
	},
	methods: {
		
	},
	created() {
		
	},
};
</script>


<style scoped lang="scss">
.card {
	&__icon {
		&::before {
			content: "\e907";
			font-family: ferrellgas!important;
			speak: none;
			font-style: normal;
			font-weight: 400;
			font-variant: normal;
			text-transform: none;
			line-height: 1;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			font-size: 5.0625rem;
		}
	}
}
</style>